/* Base path for the backend API client calls */

let BASE_MS_GW_API = "";
let CAPTCHA_BASE_URL = "";
let REACT_APP_BASE_MS_GW_API = "";
let REACT_APP_CAPTCHA_BASE_URL = "";
let REACT_APP_PAGINATION_ELEMENTS = "";
let AMBIENTE;
/*
Modifica per evitare blocco dovuto al CORS in stage e produzione:
-	Se esiste la var in env REACT_APP_AMBIENTE e vale devel oppure non esiste: 
        esporta i valori letti in env_.REACT_APP_BASE_MS_GW_API e _env_.REACT_APP_CAPTCHA_BASE_URL o process.env
-	Se esiste la var in env AMBIENTE e vale stage oppure prod allora:
        esporta i valori window.location.origin + letti in env_.REACT_APP_BASE_MS_GW_API e _env_.REACT_APP_CAPTCHA_BASE_URL 7
*/

const _env_ = (window as any)._env_ || {};

// setta il numero di elementi per pagina della tabella
if(_env_ && _env_.REACT_APP_PAGINATION_ELEMENTS){ 
    REACT_APP_PAGINATION_ELEMENTS = _env_.REACT_APP_PAGINATION_ELEMENTS;
} else if (process.env.REACT_APP_PAGINATION_ELEMENTS !== "undefined" && process.env.REACT_APP_PAGINATION_ELEMENTS){
    REACT_APP_PAGINATION_ELEMENTS = process.env.REACT_APP_PAGINATION_ELEMENTS;
}

if (process.env.REACT_APP_BASE_MS_GW_API !== "undefined" && process.env.REACT_APP_BASE_MS_GW_API){
    REACT_APP_BASE_MS_GW_API = process.env.REACT_APP_BASE_MS_GW_API;
} else {
    REACT_APP_BASE_MS_GW_API = window.location.origin;
}


if (process.env.REACT_APP_CAPTCHA_BASE_URL !== "undefined" && process.env.REACT_APP_CAPTCHA_BASE_URL) {
    CAPTCHA_BASE_URL = process.env.REACT_APP_CAPTCHA_BASE_URL;
} else {
    CAPTCHA_BASE_URL = window.location.origin ;
}

// AMBIENTE e' STAGE o PROD, la REACT_APP_BASE_MS_GW_API deve essere presa da window.location.origin
// per evitare l'errore CORS al caricamento della pagina
if (_env_ && _env_.REACT_APP_AMBIENTE) {
    AMBIENTE = _env_.REACT_APP_AMBIENTE;
} else if (process.env.REACT_APP_AMBIENTE !== "undefined" && process.env.REACT_APP_AMBIENTE) {
    AMBIENTE = process.env.REACT_APP_AMBIENTE;
}

export {
    REACT_APP_BASE_MS_GW_API, 
    REACT_APP_CAPTCHA_BASE_URL, 
    REACT_APP_PAGINATION_ELEMENTS
};
